import React from "react";
import { Icon, Header, Segment, Table, Pagination, Button, Modal, Form, Input, Search, Confirm } from 'semantic-ui-react';
import Layout from "../../comman/Layout/Layout";
import { Constants } from '../../config/appConstants';
import "../../comman/Layout/Layout.css";
import "../../assets/styles/styles.css";
import "./supervisorOverrideReason.css";
import NoResultFound from "../sharedComponent/noResultFound";

const SupervisorOverrideReason = props => {
    const myiconstyle = { color: "#f18f40", margin: "5px", cursor: "pointer" };
    return (
        <Layout>
            <Segment className="header-section">
                <Header as="h3">
                    <span className="iconify myiconstyle_1" data-icon="mdi:rectangle-outline" data-inline="false" ></span>
                    <span>Override Reason List</span>
                </Header>
                <i aria-hidden="true"
                    onClick={() => { props.onOpenModel({ data: {} }); }}
                    style={myiconstyle} className="plus circle icon">
                </i>
            </Segment>
            <Table className="ui celled table">
                <Table.Header>
                    <Table.Row>
                        <Table.HeaderCell className="tableCell"></Table.HeaderCell>
                        <Table.HeaderCell className="text-left">
                            Override Reason List
                            <Search className="theader" onSearchChange={props.onSupervisorOverrideReasonSearch}
                                placeholder={Constants.SEARCH_PLACEHOLDER} />
                        </Table.HeaderCell>
                    </Table.Row>
                </Table.Header>
                <Table.Body>
                    {props.supervisorOverride.supervisorOverrideReason.length > 0 ? props.supervisorOverride.supervisorOverrideReason.map(({ id, displayText }) => (
                        <Table.Row style={{ verticalAlign: 'baseline' }} key={id}>
                            <Table.Cell textAlign="center" className="tableCell">
                                <div className="forcastIcon">
                                    <Icon className="myiconstyle" edit name='trash alternate outline'
                                        onClick={() => { props.onDeleteSupervisorOverrideReason({ supervisorOverrideReasonId: id }); }}
                                    />
                                    <Icon className="myiconstyle" edit name='pencil'
                                        onClick={() => {
                                            props.onOpenModel({ supervisorOverrideReasonId: id });
                                        }}
                                    />
                                </div>
                            </Table.Cell>
                            <Table.Cell>{displayText}</Table.Cell>
                        </Table.Row>
                    )) :
                        <Table.Row>
                            <Table.Cell colSpan='2'>
                                <NoResultFound displayMessage={Constants.NO_RESULT_FOUND} />
                            </Table.Cell>
                        </Table.Row>
                    }
                </Table.Body>
            </Table>

            <Modal closeIcon
                open={props.supervisorOverride.isOpenModel}
                closeOnDimmerClick={false}
                onClose={() => props.onCloseModel()}
                size='tiny'
            >
                <Modal.Header>{(props.supervisorOverride.selectedSupervisorOverrideReason && props.supervisorOverride.selectedSupervisorOverrideReason.supervisorOverrideReasonId > 0) ? "Edit Supervisor Override Reason" : "Add Supervisor Override Reason"}</Modal.Header>
                <Modal.Content scrolling>
                    <Form>
                        <Form.Group inline widths='equal'>
                            <Form.Field required>
                                <label>Supervisor Override Reason:</label>
                                <Input
                                    placeholder='Enter Supervisor Override Reason'
                                    maxLength={50}
                                    value={props.supervisorOverride.selectedSupervisorOverrideReason ? props.supervisorOverride.selectedSupervisorOverrideReason.displayText : ""}
                                    onChange={(e) => { props.handleSupervisorOverrideReasonChange(e, { name: 'displayText', value: e.target.value }) }}
                                />
                            </Form.Field>
                        </Form.Group>
                    </Form>
                </Modal.Content>
                <Modal.Actions>
                    {props.supervisorOverride.isEditSupervisorOverrideReason ?
                        <Button disabled={props.supervisorOverride.isSetButtonDisabled} type="submit" primary onClick={() => props.onSaveSupervisorOverrideReason(props.supervisorOverride.selectedSupervisorOverrideReason.supervisorOverrideReasonId)}> Update </Button> :
                        <Button disabled={props.supervisorOverride.isSetButtonDisabled} type="submit" primary onClick={() => props.onSaveSupervisorOverrideReason()}> Save </Button>
                    }
                    <Button secondary onClick={() => props.onCloseModel()}>Back</Button>
                </Modal.Actions>
            </Modal>
            <Confirm
                closeIcon
                open={props.supervisorOverride.isDeleteConfirm}
                content="Are you sure? Do you want to delete this Supervisor override reason?"
                header='Confirmation'
                size="tiny"
                onCancel={() => { props.onCancelDelete(); }}
                onConfirm={() => { props.onConfirmDelete(); }}
            />
            {props.supervisorOverride.supervisorOverrideReason && props.supervisorOverride.supervisorOverrideReason.length > 0 &&
                <Pagination floated="right"
                    activePage={props.supervisorOverride.pagination.activePage}
                    onPageChange={props.onPageChange}
                    ellipsisItem={null}
                    firstItem={null}
                    lastItem={null}
                    totalPages={props.supervisorOverride.pagination.totalCount}
                />
            }
        </Layout >
    );
}

export default SupervisorOverrideReason;

SupervisorOverrideReason.displayName = "SupervisorOverrideReason";